//export const baseURL = "http://24.144.87.74:5000/";
//export const baseURL = "http://192.168.100.123:3001/"; // Local
export const baseURL = "http://64.23.180.227:3001/"; // Preprod Server
export const key = "lPhXzI3Fv;TF(>R";


